import GlimpseHeader from "components/career-header/career-header.component";
import { IVideoPlayer } from "interfaces/VideoStreamingInterface";
import React, { useEffect, useRef } from "react";
import VideoPlayer from "./video-player.component";
import ReactPlayer from "react-player";

const VideoStreaming: React.FC<IVideoPlayer & { leftButton?: React.ReactNode; rightButton?: React.ReactNode }> = ({
  header,
  video_url,
  onEnd,
  onPaused,
  onProgress,
  onSeek,
  onStart,
  thumbnail,
  videoStatus,
  onBuffer,
  onError,
  popupClass,
  handleSortNow,
  handleNext,
  handleBack,
  enableNext,
  currentSlide,
  enableButtons,
  currentIndex,
  isPaused,
  count,
  activeIndex,
  index,
  description,
  image,
  title,
  subtitle,
  handleSlideBack,
  handleSlideNext,
  leftButton,
  rightButton,
}) => {
  const videoRef = useRef<ReactPlayer>(null);

  useEffect(() => {
    videoRef.current?.getInternalPlayer()?.pause();
  }, [currentSlide]);

  return (
    <div
      className="h-full"
    >
      <div className={`h-[160px] mb-3 flex flex-col justify-between ${activeIndex !== index ? "invisible" : ""}`}>
        <GlimpseHeader
          title={header?.title as string}
          subtitle={header?.subtitle as string}
          image={header?.image as string}
        />
        <div className="text-[15px] leading-[20px] w-[276px]">
          {header?.children}
        </div>
      </div>
      <div className="relative w-[276px]">
        <VideoPlayer
          videoRef={videoRef}
          key={video_url}
          video_url={video_url}
          onBuffer={onBuffer}
          onStart={onStart}
          onEnd={onEnd}
          onProgress={onProgress}
          onPaused={onPaused}
          onError={onError}
          thumbnail={thumbnail}
          onSeek={onSeek}
          className="h-full"
          videoStatus={videoStatus}
          isPaused={isPaused}
          count={count}
          activeIndex={activeIndex}
          index={index}
          enableNext={enableNext}
          description={description}
          image={image}
          title={title}
          subtitle={subtitle}
          handleSlideBack={handleSlideBack}
          handleSlideNext={handleSlideNext}
        />

        {/* Arrows positioned relative to the video card only */}
        {leftButton && (
          <div className="absolute top-1/2 -translate-y-1/2 -left-14">
            {leftButton}
          </div>
        )}
        {rightButton && (
          <div className="absolute top-1/2 -translate-y-1/2 -right-14">
            {rightButton}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoStreaming;
